import { Component, OnInit } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Router } from "@angular/router";
import { User, InviteListConfig, UserService } from "../../../shared";

@Component({
  selector: "invite-manager",
  templateUrl: "./invite-manager.component.html",
  styleUrls: [
    "../../../../../node_modules/sweetalert2/src/sweetalert2.scss",
    "../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class InviteManagerComponent implements OnInit {
  public inviteUsers: User[];
  public currentUser: User;
  public isAuthenticated: boolean;
  public config: InviteListConfig = new InviteListConfig();
  public inviteUsersField = new FormControl();

  constructor(private router: Router, private userService: UserService) {
    this.inviteUsersField.valueChanges.subscribe((value) => {
      this.searchUser(value);
    });

    this.userService.currentUser.subscribe((userData: User) => {
      this.currentUser = userData;
    });

    this.userService.isAuthenticated.subscribe((authenticated) => {
      this.isAuthenticated = authenticated;

      if (authenticated) {
        this.setListTo({ type: "received" });
      }
    });
  }

  ngOnInit() {}

  public fetchInviteUsers(users) {
    this.inviteUsers = users;
  }

  public searchUser(value: Object) {
    if (value !== undefined && value[0] !== undefined) {
      if (this.config.type === "received") {
        this.setListTo({
          type: "received",
          sender: value[0]["username"],
        });
      }
      if (this.config.type === "sent") {
        this.setListTo({
          type: "sent",
          recipient: value[0]["username"],
        });
      }
    } else {
      const currentType = this.config.type;
      this.setListTo({ type: currentType });
    }
  }

  public setListTo(filters: InviteListConfig) {
    if (!this.isAuthenticated) {
      this.router.navigateByUrl("/login");
      return;
    }
    this.config = filters;
  }
}
